(function () {
  var CATEGORY_ORDER = [
    'Motor',
    'Turbo',
    'Intake',
    'Intercooler',
    'Uitlaat',
    'Software / tuning',
    'Onderstel',
    'Remmen',
    'Velgen',
    'Banden',
    'Exterieur',
    'Interieur',
    'Elektronica',
    'Overig',
  ];

  initOverviewPages();
  initBuildDetailPages();
  initProductBuildBlocks();
  initFocusGalleries();
  initGalleryPreloading();
  initProDetailInteractions();
  initLightbox();
  initReadMore();
  initLikes();
  initFavorites();
  initComments();
  initShareButtons();
  initBuildTracking();

  function initOverviewPages() {
    var garageRoots = document.querySelectorAll('[data-hs-garage]');

    garageRoots.forEach(function (root) {
      var grid = root.querySelector('[data-garage-grid]');
      var buildsUrl = root.dataset.buildsUrl;
      var detailBaseUrl = root.dataset.detailBaseUrl || '/apps/garage/public/builds';
      var searchInput = root.querySelector('[data-garage-search]');
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-garage-filter]'));
      var brandSelect = root.querySelector('[data-garage-filter="brand"]');
      var modelSelect = root.querySelector('[data-garage-filter="model"]');
      var sortSelect = root.querySelector('[data-garage-sort]');
      var resetButton = root.querySelector('[data-garage-reset]');
      var count = root.querySelector('[data-garage-count]');
      var empty = root.querySelector('[data-garage-empty]');
      var loading = root.querySelector('[data-garage-loading]');
      var totalBuilds = root.querySelector('[data-garage-total-builds]');
      var totalParts = root.querySelector('[data-garage-total-parts]');
      var pagination = root.querySelector('[data-garage-pagination]');
      var state = {
        builds: [],
        page: 1,
        pageSize: Number(root.dataset.pageSize || 16),
      };
      root._hsGarageState = state;

      if (!grid || !buildsUrl) {
        bindFilters(root);
        return;
      }

      loadJson(buildsUrl)
        .then(function (payload) {
          var builds = payload.builds || [];
          state.builds = applyTrendingBadges(builds);
          if (loading) loading.hidden = true;

          if (totalBuilds) totalBuilds.textContent = String(builds.length);
          if (totalParts) {
            totalParts.textContent = String(builds.reduce(function (sum, build) {
              return sum + Number(build.modificationCount || 0);
            }, 0));
          }

          updateModelFilterOptions(root);
          renderProShowcase(root, detailBaseUrl);
          renderOverview(root, detailBaseUrl);
          initGarageActivityFeed(root, detailBaseUrl);
        })
        .catch(function () {
          if (loading) loading.hidden = true;
          if (empty) {
            empty.textContent = 'H&S Garage builds konden nu niet worden geladen.';
            empty.hidden = false;
          }
          if (count) count.textContent = '0 garages';
        });

      if (searchInput) searchInput.addEventListener('input', function () {
        state.page = 1;
        renderOverview(root, detailBaseUrl);
      });

      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          if (select === brandSelect) {
            updateModelFilterOptions(root);
          }
          state.page = 1;
          renderOverview(root, detailBaseUrl);
        });
      });

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          state.page = 1;
          renderOverview(root, detailBaseUrl);
        });
      }

      if (resetButton) {
        resetButton.addEventListener('click', function () {
          if (searchInput) searchInput.value = '';
          selects.forEach(function (select) {
            select.value = '';
          });
          if (sortSelect) sortSelect.value = 'newest';
          updateModelFilterOptions(root);
          state.page = 1;
          renderOverview(root, detailBaseUrl);
        });
      }

      if (pagination) {
        pagination.addEventListener('click', function (event) {
          var button = event.target.closest('[data-garage-page]');
          if (!button) return;

          state.page += Number(button.dataset.garagePage || 0);
          renderOverview(root, detailBaseUrl);
        });
      }
    });
  }

  function updateModelFilterOptions(root) {
    var brandSelect = root.querySelector('[data-garage-filter="brand"]');
    var modelSelect = root.querySelector('[data-garage-filter="model"]');
    if (!brandSelect || !modelSelect) return;

    var brand = brandSelect.value;
    var selectedOption = modelSelect.options[modelSelect.selectedIndex];

    Array.prototype.slice.call(modelSelect.options).forEach(function (option) {
      if (!option.value) {
        option.hidden = false;
        option.disabled = false;
        option.textContent = brand ? 'Alle ' + brand + ' modellen' : 'Alle modellen';
        return;
      }

      var optionBrand = option.dataset.brand || '';
      var shouldShow = !brand || optionBrand === brand;
      option.hidden = !shouldShow;
      option.disabled = !shouldShow;
    });

    if (selectedOption && selectedOption.value && brand && selectedOption.dataset.brand !== brand) {
      modelSelect.value = '';
    }
  }

  function bindFilters(root) {
    updateFilterState(root);
  }

  function updateFilterState(root) {
    if (root._hsGarageState) {
      renderOverview(root, root.dataset.detailBaseUrl || '/apps/garage/public/builds');
      return;
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-garage-card]'));
    var searchInput = root.querySelector('[data-garage-search]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-garage-filter]'));
    var count = root.querySelector('[data-garage-count]');
    var empty = root.querySelector('[data-garage-empty]');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var isVisible = matchesCard(card, searchInput, selects);
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (count) {
      count.textContent = visibleCount + (visibleCount === 1 ? ' garage' : ' garages');
    }

    if (empty) {
      empty.hidden = visibleCount > 0;
    }
  }

  function renderOverview(root, detailBaseUrl) {
    var state = root._hsGarageState;
    if (!state) return;

    var grid = root.querySelector('[data-garage-grid]');
    var count = root.querySelector('[data-garage-count]');
    var empty = root.querySelector('[data-garage-empty]');
    var pagination = root.querySelector('[data-garage-pagination]');
    var sortSelect = root.querySelector('[data-garage-sort]');
    var filtered = state.builds.filter(function (build) {
      return matchesBuild(build, root);
    });
    filtered = sortBuilds(filtered, sortSelect ? sortSelect.value : 'newest');
    var totalPages = Math.max(1, Math.ceil(filtered.length / state.pageSize));

    state.page = Math.min(Math.max(1, state.page), totalPages);

    var start = (state.page - 1) * state.pageSize;
    var pageBuilds = filtered.slice(start, start + state.pageSize);

    if (grid) {
      grid.innerHTML = pageBuilds.map(function (build) {
        return buildCardTemplate(build, detailBaseUrl);
      }).join('');
    }

    if (count) {
      count.textContent = filtered.length + (filtered.length === 1 ? ' garage' : ' garages');
    }

    if (empty) {
      empty.hidden = filtered.length > 0;
    }

    if (pagination) {
      pagination.hidden = filtered.length <= state.pageSize;
      pagination.innerHTML = filtered.length <= state.pageSize ? '' : [
        '<button class="hs-garage__button hs-garage__button--ghost" type="button" data-garage-page="-1"' + (state.page <= 1 ? ' disabled' : '') + '>Vorige</button>',
        '<span>Pagina ' + state.page + ' van ' + totalPages + '</span>',
        '<button class="hs-garage__button hs-garage__button--ghost" type="button" data-garage-page="1"' + (state.page >= totalPages ? ' disabled' : '') + '>Volgende</button>',
      ].join('');
    }
  }

  function renderHighlights(root, detailBaseUrl) {
    var state = root._hsGarageState;
    if (!state || !state.builds.length) return;

    var wrapper = root.querySelector('[data-garage-highlights]');
    var newSection = root.querySelector('[data-garage-new-section]');
    var newGrid = root.querySelector('[data-garage-new-grid]');
    var trendingSection = root.querySelector('[data-garage-trending-section]');
    var trendingGrid = root.querySelector('[data-garage-trending-grid]');
    var newest = sortBuilds(state.builds.filter(function (build) {
      return dateValue(build.lastUpdateAt || build.createdAt) > 0;
    }), 'latest_update').slice(0, 4);
    var trending = state.builds
      .filter(function (build) {
        return Number(build.trendingScore || build.viewCount || build.favoriteCount || build.shareCount || 0) > 0;
      })
      .sort(function (a, b) {
        return Number(b.trendingScore || 0) - Number(a.trendingScore || 0);
      })
      .slice(0, 3);

    if (newGrid) newGrid.innerHTML = newest.map(function (build) {
      return highlightCardTemplate(build, detailBaseUrl, build.isNew ? 'NEW' : 'Update');
    }).join('');
    if (newSection) newSection.hidden = newest.length === 0;

    if (trendingGrid) trendingGrid.innerHTML = trending.map(function (build, index) {
      return highlightCardTemplate(build, detailBaseUrl, 'Trending #' + (index + 1));
    }).join('');
    if (trendingSection) trendingSection.hidden = trending.length === 0;

    if (wrapper) {
      wrapper.hidden = newest.length === 0 && trending.length === 0;
    }
  }

  function initGarageActivityFeed(root, detailBaseUrl) {
    if (root._hsGarageActivityFeedStarted) return;

    var state = root._hsGarageState;
    var shownEvents = readShownActivityEvents();
    var events = activityEventsFromBuilds(state && state.builds ? state.builds : [], detailBaseUrl).filter(function (event) {
      return !shownEvents[event.key];
    });
    if (!events.length) return;

    root._hsGarageActivityFeedStarted = true;

    events.slice(0, 3).forEach(function (event, index) {
      window.setTimeout(function () {
      if (!document.hidden) {
          showGarageActivityToast(event);
          markActivityEventShown(event);
      }
      }, 4200 + index * 12000);
    });
  }

  function activityEventsFromBuilds(builds, detailBaseUrl) {
    var events = [];
    var seen = {};
    var now = Date.now();
    var recentCutoff = now - 14 * 24 * 60 * 60 * 1000;

    builds.forEach(function (build) {
      var title = buildTitle(build);
      var owner = activityOwnerName(build);
      var href = build.url || detailUrl(detailBaseUrl, build);
      var image = build.mainImage || '';
      var imageAlt = build.mainImageAlt || title;
      var publishedTime = dateValue(build.publishedAt || build.createdAt);
      var updateTime = dateValue(build.lastUpdateAt || build.createdAt);
      var publicTime = publishedTime || dateValue(build.createdAt);
      var hasRealUpdate = updateTime && publicTime && updateTime > publicTime + 5 * 60 * 1000;
      var event = null;

      if (hasRealUpdate && updateTime >= recentCutoff) {
        event = {
          type: 'updated',
          kicker: 'Update',
          title: owner + ' heeft de garage bijgewerkt',
          body: title,
          href: href,
          image: image,
          imageAlt: imageAlt,
          time: updateTime,
        };
      } else if (publicTime && publicTime >= recentCutoff) {
        event = {
          type: 'published',
          kicker: 'Nieuw online',
          title: owner + ' heeft een garage online gezet',
          body: title,
          href: href,
          image: image,
          imageAlt: imageAlt,
          time: publicTime,
        };
      }

      if (event) {
        event.key = activityEventKey(event);
        if (!seen[event.key]) {
          seen[event.key] = true;
          events.push(event);
        }
      }
    });

    return events
      .filter(function (event) {
        return event.time > 0 && event.title;
      })
      .sort(function (a, b) {
        return b.time - a.time;
      })
      .slice(0, 8);
  }

  function activityEventKey(event) {
    return [
      event.type || 'activity',
      event.href || event.title || '',
      Math.floor(Number(event.time || 0) / 60000),
    ].join('|');
  }

  function readShownActivityEvents() {
    var key = 'hsGarageActivitySeen';
    var maxAge = 6 * 60 * 60 * 1000;
    var now = Date.now();
    var next = {};

    try {
      var stored = JSON.parse(window.sessionStorage.getItem(key) || '{}');
      Object.keys(stored).forEach(function (eventKey) {
        if (now - Number(stored[eventKey] || 0) < maxAge) {
          next[eventKey] = stored[eventKey];
        }
      });
      window.sessionStorage.setItem(key, JSON.stringify(next));
    } catch (error) {
      next = {};
    }

    return next;
  }

  function markActivityEventShown(event) {
    if (!event || !event.key) return;

    try {
      var shown = readShownActivityEvents();
      shown[event.key] = Date.now();
      window.sessionStorage.setItem('hsGarageActivitySeen', JSON.stringify(shown));
    } catch (error) {
      return;
    }
  }

  function activityOwnerName(build) {
    return build.ownerDisplayName || 'Een H&S Corse klant';
  }

  function firstMountedModification(build) {
    var modifications = build.modifications || [];
    return modifications.find(function (modification) {
      return (modification.status || 'mounted') === 'mounted';
    }) || modifications[0] || null;
  }

  function activityModLabel(modification) {
    var category = normalize(modification && modification.category);
    var title = String((modification && modification.title) || '').trim();

    if (category === 'uitlaat') return 'een uitlaat';
    if (category === 'intake') return 'een intake';
    if (category === 'intercooler') return 'een intercooler';
    if (category === 'turbo') return 'een turbo upgrade';
    if (category === 'remmen') return 'remmen';
    if (category === 'onderstel') return 'onderstel upgrades';
    if (title && title.length <= 34) return title;
    if (category) return 'een ' + category + ' upgrade';
    return 'een onderdeel';
  }

  function showGarageActivityToast(event) {
    if (!event || !event.title) return;

    var container = document.querySelector('[data-garage-activity-feed]');
    if (!container) {
      container = document.createElement('div');
      container.className = 'hs-garage-activity-feed';
      container.setAttribute('data-garage-activity-feed', '');
      container.setAttribute('aria-live', 'polite');
      document.body.appendChild(container);
    }

    var itemTag = event.href ? 'a' : 'div';
    var item = document.createElement(itemTag);
    item.className = 'hs-garage-activity-toast hs-garage-activity-toast--' + classToken(event.type || 'update');
    if (event.href) item.href = event.href;
    item.innerHTML = [
      '<span class="hs-garage-activity-toast__media">',
      event.image ? responsiveImage(event.image, event.imageAlt || event.title, { width: 180, widths: [120, 180, 260], sizes: '72px' }) : '<span></span>',
      '</span>',
      '<span class="hs-garage-activity-toast__content">',
      '<small>' + escapeHtml(event.kicker || 'Live activiteit') + '</small>',
      '<strong>' + escapeHtml(event.title) + '</strong>',
      event.body ? '<em>' + escapeHtml(event.body) + '</em>' : '',
      '</span>',
    ].join('');

    container.appendChild(item);

    while (container.children.length > 3) {
      container.removeChild(container.firstElementChild);
    }

    window.setTimeout(function () {
      item.classList.add('is-leaving');
      window.setTimeout(function () {
        if (item.parentNode) item.parentNode.removeChild(item);
      }, 280);
    }, 6800);
  }

  function renderProShowcase(root, detailBaseUrl) {
    var state = root._hsGarageState;
    if (!state) return;

    var builds = state.builds || [];
    var wrapper = root.querySelector('[data-garage-showcase]');
    var spotlight = root.querySelector('[data-garage-spotlight]');
    var livePanel = root.querySelector('[data-garage-live-panel]');
    var trendingList = root.querySelector('[data-garage-trending-list]');

    if (!builds.length) {
      if (wrapper) wrapper.hidden = true;
      if (livePanel) {
        livePanel.innerHTML = [
          '<div class="hs-garage-live-row">',
          '<div class="hs-garage-live-row__image"></div>',
          '<div><strong>Nog geen online garages</strong><span>De eerste klantgarage verschijnt hier zodra hij live staat.</span></div>',
          '</div>',
        ].join('');
      }
      if (spotlight) spotlight.innerHTML = '';
      if (trendingList) trendingList.innerHTML = '';
      return;
    }

    var newest = sortBuilds(builds, 'newest')[0];
    var mostViewed = sortBuilds(builds, 'most_viewed')[0] || newest;
    var latestUpdated = sortBuilds(builds.filter(function (build) {
      return dateValue(build.lastUpdateAt || build.createdAt) > 0;
    }), 'latest_update')[0] || newest;
    var topViewed = builds.slice().sort(function (a, b) {
      return Number(b.viewCount || 0) - Number(a.viewCount || 0) || addedDateValue(b) - addedDateValue(a);
    }).slice(0, 3);

    if (wrapper) wrapper.hidden = false;
    if (spotlight) spotlight.innerHTML = spotlightTemplate(newest, detailBaseUrl);
    if (trendingList) {
      trendingList.innerHTML = topViewed.map(function (build, index) {
        return topViewedCardTemplate(index + 1, build, detailBaseUrl);
      }).join('');
    }
    if (livePanel) {
      livePanel.innerHTML = [
        liveRowTemplate({
          image: newest.mainImage,
          imageAlt: newest.mainImageAlt || buildTitle(newest),
          title: 'Nieuw online',
          text: buildTitle(newest) + (buildTinyMeta(newest) ? ' · ' + buildTinyMeta(newest) : ''),
          href: newest.url || detailUrl(detailBaseUrl, newest),
        }),
        liveRowTemplate({
          image: mostViewed.mainImage,
          imageAlt: mostViewed.mainImageAlt || buildTitle(mostViewed),
          title: 'Meest bekeken',
          text: buildTitle(mostViewed) + ' · ' + formatNumber(mostViewed.viewCount || 0) + ' weergaven',
          href: mostViewed.url || detailUrl(detailBaseUrl, mostViewed),
        }),
        liveRowTemplate({
          image: latestUpdated.mainImage,
          imageAlt: latestUpdated.mainImageAlt || buildTitle(latestUpdated),
          title: 'Laatst bijgewerkt',
          text: buildTitle(latestUpdated) + (buildTinyMeta(latestUpdated) ? ' · ' + buildTinyMeta(latestUpdated) : ''),
          href: latestUpdated.url || detailUrl(detailBaseUrl, latestUpdated),
        }),
      ].join('');
    }
  }

  function spotlightTemplate(build, detailBaseUrl) {
    var title = buildTitle(build);
    var href = build.url || detailUrl(detailBaseUrl, build);
    var description = truncate(build.description || 'De nieuwste garage in H&S Corse Clienti. Bekijk de foto\'s, onderdelen en setup van deze klantbuild.', 180);
    var pills = [
      build.stage,
      build.powerHp ? build.powerHp + ' PK' : '',
      Number(build.likeCount || 0) + (Number(build.likeCount || 0) === 1 ? ' like' : ' likes'),
      Number(build.favoriteCount || 0) + (Number(build.favoriteCount || 0) === 1 ? ' favoriet' : ' favorieten'),
      Number(build.commentCount || 0) + (Number(build.commentCount || 0) === 1 ? ' reactie' : ' reacties'),
    ].filter(Boolean);

    return [
      build.mainImage ? responsiveImage(build.mainImage, build.mainImageAlt || title, { width: 1000, widths: [480, 720, 1000, 1400], sizes: '(max-width: 900px) 100vw, 58vw' }) : '<div class="hs-garage-spotlight__fallback"></div>',
      '<div class="hs-garage-spotlight__body">',
      '<div class="hs-garage-badge-row"><span class="hs-garage-pro-badge hs-garage-pro-badge--red">NIEUW ONLINE</span></div>',
      '<h2>' + escapeHtml(title) + '</h2>',
      '<p>' + escapeHtml(description) + '</p>',
      '<div class="hs-garage-spotlight__footer">',
      pills.map(function (pill) {
        return '<span class="hs-garage-spec-pill">' + escapeHtml(pill) + '</span>';
      }).join(''),
      '<a class="hs-garage__button" href="' + escapeHtml(href) + '">Bekijk garage</a>',
      '</div>',
      '</div>',
    ].join('');
  }

  function topViewedCardTemplate(index, build, detailBaseUrl) {
    var title = buildTitle(build);
    var href = build.url || detailUrl(detailBaseUrl, build);
    var image = build.mainImage || '';
    var views = Number(build.viewCount || 0);
    var likes = Number(build.likeCount || 0);
    var favorites = Number(build.favoriteCount || 0);
    var comments = Number(build.commentCount || 0);
    var model = [build.brand, build.model, build.variant].filter(Boolean).join(' ');

    return [
      '<a class="hs-garage-top-viewed-card" href="' + escapeHtml(href) + '">',
      '<span class="hs-garage-top-viewed-card__rank">#' + index + '</span>',
      '<span class="hs-garage-top-viewed-card__media">',
      image ? responsiveImage(image, build.mainImageAlt || title, { width: 420, widths: [240, 360, 520, 720], sizes: '(max-width: 900px) 100vw, 360px' }) : '<span class="hs-garage-pro-row-fallback"></span>',
      '</span>',
      '<span class="hs-garage-top-viewed-card__body">',
      '<strong>' + escapeHtml(title) + '</strong>',
      model ? '<em>' + escapeHtml(model) + '</em>' : '',
      '<span class="hs-garage-top-viewed-card__metrics">',
      '<b>' + escapeHtml(formatNumber(views) + 'x bekeken') + '</b>',
      '<b class="hs-garage-top-viewed-card__like">♥ ' + escapeHtml(formatNumber(likes)) + '</b>',
      '<b class="hs-garage-top-viewed-card__favorite">★ ' + escapeHtml(formatNumber(favorites)) + '</b>',
      '<b class="hs-garage-top-viewed-card__comments">' + escapeHtml(formatNumber(comments) + (comments === 1 ? ' reactie' : ' reacties')) + '</b>',
      '</span>',
      '</span>',
      '</a>',
    ].join('');
  }

  function liveRowTemplate(row) {
    var openTag = row.href
      ? '<a class="hs-garage-live-row" href="' + escapeHtml(row.href) + '" aria-label="Bekijk ' + escapeHtml(row.text || row.title || 'garage') + '">'
      : '<div class="hs-garage-live-row">';
    var closeTag = row.href ? '</a>' : '</div>';

    return [
      openTag,
      row.image ? responsiveImage(row.image, row.imageAlt || row.title, { width: 260, widths: [160, 260, 360], sizes: '96px' }) : '<div class="hs-garage-live-row__image"></div>',
      '<div><strong>' + escapeHtml(row.title) + '</strong><span>' + escapeHtml(row.text || '') + '</span></div>',
      closeTag,
    ].join('');
  }

  function rankRowTemplate(index, build, detailBaseUrl) {
    var title = buildTitle(build);
    var href = build.url || detailUrl(detailBaseUrl, build);
    var metric = Number(build.viewCount || 0) > 0
      ? formatNumber(build.viewCount) + ' weergaven'
      : (build.brand || 'H&S Garage');

    return [
      '<a class="hs-garage-pro-rank-row" href="' + escapeHtml(href) + '">',
      '<span class="hs-garage-pro-rank">' + index + '</span>',
      build.mainImage ? responsiveImage(build.mainImage, build.mainImageAlt || title, { width: 260, widths: [160, 260, 360], sizes: '76px' }) : '<span class="hs-garage-pro-row-fallback"></span>',
      '<span><strong>' + escapeHtml(title) + '</strong><em>' + escapeHtml(buildTinyMeta(build, metric)) + '</em></span>',
      '</a>',
    ].join('');
  }

  function topProductRowTemplate(index, product) {
    var content = [
      '<span class="hs-garage-pro-rank">' + index + '</span>',
      product.imageUrl ? responsiveImage(product.imageUrl, product.imageAlt || product.title, { width: 220, widths: [140, 220, 320], sizes: '72px' }) : '<span class="hs-garage-pro-row-fallback"></span>',
      '<span><strong>' + escapeHtml(product.title) + '</strong><em>Gekoppeld aan ' + product.count + (product.count === 1 ? ' online garage' : ' online garages') + '</em></span>',
    ].join('');

    if (product.url) {
      return '<a class="hs-garage-pro-rank-row" href="' + escapeHtml(product.url) + '">' + content + '</a>';
    }

    return '<div class="hs-garage-pro-rank-row">' + content + '</div>';
  }

  function topLinkedProducts(builds) {
    var products = {};

    builds.forEach(function (build) {
      var usedInBuild = {};

      (build.modifications || []).forEach(function (modification) {
        var product = modification.product;
        if (!product) return;

        var key = product.id || product.handle || product.url || product.title;
        if (!key || usedInBuild[key]) return;

        usedInBuild[key] = true;

        if (!products[key]) {
          products[key] = {
            title: product.title || modification.title || 'H&S onderdeel',
            url: product.url || '',
            imageUrl: product.imageUrl || modification.imageUrl || '',
            imageAlt: product.imageAlt || modification.imageAlt || product.title || modification.title || '',
            count: 0,
          };
        }

        products[key].count += 1;
      });
    });

    return Object.keys(products).map(function (key) {
      return products[key];
    }).sort(function (a, b) {
      return b.count - a.count || String(a.title).localeCompare(String(b.title));
    }).slice(0, 3);
  }

  function popularModelGroup(builds) {
    var groups = {};

    builds.forEach(function (build) {
      var label = [build.brand, build.model].filter(Boolean).join(' ') || build.model || build.brand || 'H&S Garage';
      if (!groups[label]) {
        groups[label] = {
          label: label,
          count: 0,
          image: build.mainImage || '',
          imageAlt: build.mainImageAlt || label,
        };
      }
      groups[label].count += 1;
      if (!groups[label].image && build.mainImage) {
        groups[label].image = build.mainImage;
        groups[label].imageAlt = build.mainImageAlt || label;
      }
    });

    return Object.keys(groups).map(function (key) {
      return groups[key];
    }).sort(function (a, b) {
      return b.count - a.count || String(a.label).localeCompare(String(b.label));
    })[0] || {
      label: 'H&S Garage',
      count: builds.length,
      image: builds[0] && builds[0].mainImage,
      imageAlt: 'H&S Garage',
    };
  }

  function trendingValue(build) {
    return Number(build.trendingScore || 0) ||
      Number(build.viewCount || 0) +
      Number(build.uniqueViewCount || 0) * 3 +
      Number(build.shareCount || 0) * 8 +
      Number(build.favoriteCount || 0) * 10 +
      Number(build.likeCount || 0) * 2;
  }

  function applyTrendingBadges(builds) {
    builds.forEach(function (build) {
      delete build._hsGarageTrendingRank;
    });

    builds.slice().sort(function (a, b) {
      return trendingValue(b) - trendingValue(a) || addedDateValue(b) - addedDateValue(a);
    }).filter(function (build) {
      return trendingValue(build) > 0;
    }).slice(0, 3).forEach(function (build, index) {
      build._hsGarageTrendingRank = index + 1;
    });

    return builds;
  }

  function sortBuilds(builds, mode) {
    var next = builds.slice();
    var selected = mode || 'newest';

    next.sort(function (a, b) {
      if (selected === 'oldest') return addedDateValue(a) - addedDateValue(b);
      if (selected === 'latest_update') return dateValue(b.lastUpdateAt || b.createdAt) - dateValue(a.lastUpdateAt || a.createdAt);
      if (selected === 'most_viewed') return Number(b.viewCount || 0) - Number(a.viewCount || 0);
      return addedDateValue(b) - addedDateValue(a);
    });

    return next;
  }

  function matchesBuild(build, root) {
    var searchInput = root.querySelector('[data-garage-search]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-garage-filter]'));
    var query = normalize(searchInput && searchInput.value);
    var visible = !query || buildSearchText(build).indexOf(query) !== -1;

    selects.forEach(function (select) {
      var value = normalize(select.value);
      var key = select.dataset.garageFilter;
      if (!value || !visible) return;

      if (key === 'categories') {
        visible = categoriesForBuild(build).join(' ').indexOf(value) !== -1;
      } else if (key === 'model') {
        visible = modelMatchesFilter(build, value);
      } else if (key === 'stage') {
        visible = stageMatchesFilter(build.stage, value);
      } else {
        visible = normalize(build[key]).indexOf(value) !== -1;
      }
    });

    return visible;
  }

  function modelMatchesFilter(build, value) {
    var normalizedValue = normalize(value);
    var modelText = normalize([build.model, build.variant].filter(Boolean).join(' '));

    if (!normalizedValue) return true;
    if (modelText.indexOf(normalizedValue) !== -1) return true;

    if (['500', '595', '695'].indexOf(normalizedValue) !== -1) {
      return modelText.indexOf('500 595 695') !== -1 || modelText.indexOf('500/595/695') !== -1;
    }

    if (normalizedValue === 'grande punto' || normalizedValue === 'punto evo') {
      return modelText.indexOf('grande punto punto evo') !== -1 || modelText.indexOf('grande punto / punto evo') !== -1;
    }

    return false;
  }

  function stageMatchesFilter(stage, value) {
    var buildStage = normalizeStage(stage);
    var selectedStage = normalizeStage(value);
    if (!selectedStage) return true;
    return buildStage === selectedStage;
  }

  function normalizeStage(value) {
    return normalize(value).replace(/\s*\+\s*/g, '+');
  }

  function buildSearchText(build) {
    return normalize([
      buildTitle(build),
      build.ownerDisplayName,
      build.brand,
      build.model,
      build.variant,
      build.year,
      build.stage,
      build.powerHp,
      build.description,
      categoriesForBuild(build).join(' '),
      (build.modifications || []).map(function (modification) {
        return [modification.title, modification.brand, modification.category].filter(Boolean).join(' ');
      }).join(' '),
    ].filter(Boolean).join(' '));
  }

  function categoriesForBuild(build) {
    return unique((build.modifications || []).map(function (modification) {
      return modification.category || 'Overig';
    }));
  }

  function matchesCard(card, searchInput, selects) {
    var query = normalize(searchInput && searchInput.value);
    var searchHaystack = normalize(card.dataset.search);
    var visible = query === '' || searchHaystack.indexOf(query) !== -1;

    selects.forEach(function (select) {
      var value = normalize(select.value);
      var key = select.dataset.garageFilter;
      var dataValue = normalize(card.dataset[key]);

      if (!value || !visible) return;
      visible = dataValue.indexOf(value) !== -1;
    });

    return visible;
  }

  function initBuildDetailPages() {
    var detailRoots = document.querySelectorAll('[data-hs-garage-build-detail]');

    detailRoots.forEach(function (root) {
      var params = new URLSearchParams(window.location.search);
      var slug = params.get('build') || params.get('slug');
      var baseUrl = root.dataset.buildsBaseUrl || '/apps/garage/public/builds';
      var loading = root.querySelector('[data-garage-detail-loading]');
      var content = root.querySelector('[data-garage-detail-content]');
      var title = root.querySelector('[data-garage-detail-title]');
      var meta = root.querySelector('[data-garage-detail-meta]');
      var hero = root.querySelector('[data-garage-detail-hero]');
      var heroContent = root.querySelector('.hs-garage__detail-hero-content');

      if (!slug) {
        if (loading) loading.textContent = 'Geen build gekozen.';
        return;
      }

      loadJson(baseUrl.replace(/\/$/, '') + '/' + encodeURIComponent(slug))
        .then(function (payload) {
          var build = payload.build;
          if (!build) throw new Error('Build niet gevonden');

          if (loading) loading.hidden = true;
          if (title) title.textContent = buildTitle(build);
          if (meta) meta.innerHTML = buildMeta(build).map(function (item) {
            return '<span>' + escapeHtml(item) + '</span>';
          }).join('') + buildEngagementTemplate(build);
          if (heroContent) {
            var existingOwnerCard = heroContent.querySelector('.hs-garage-owner-card');
            if (existingOwnerCard) existingOwnerCard.remove();
            heroContent.insertAdjacentHTML('beforeend', ownerCardTemplate(build));
          }
          root.dataset.garageBuildSlug = build.slug || build.handle || slug;
          trackBuildView(root.dataset.garageBuildSlug);

          if (hero && build.mainImage) {
            var image = document.createElement('img');
            image.src = optimizedImageUrl(build.mainImage, 1600);
            image.srcset = optimizedImageSrcset(build.mainImage, [720, 1100, 1600, 1800]);
            image.sizes = '100vw';
            image.alt = build.mainImageAlt || buildTitle(build);
            image.loading = 'eager';
            image.decoding = 'async';
            image.fetchPriority = 'high';
            hero.insertBefore(image, hero.firstChild);
          }

          if (content) {
            content.innerHTML = detailContentTemplate(build);
            content.hidden = false;
          }
        })
        .catch(function () {
          if (loading) loading.textContent = 'Build kon niet worden geladen.';
        });
    });
  }

  function initProductBuildBlocks() {
    var productBlocks = document.querySelectorAll('[data-hs-garage-product-builds]');

    productBlocks.forEach(function (block) {
      var buildsUrl = block.dataset.buildsUrl;
      var grid = block.querySelector('[data-garage-product-grid]');
      var count = block.querySelector('[data-garage-product-count]');

      if (!buildsUrl || !grid) return;

      loadJson(buildsUrl)
        .then(function (payload) {
          var builds = payload.builds || [];

          if (!builds.length) {
            block.hidden = true;
            return;
          }

          block.hidden = false;
          if (count) {
            count.textContent = 'Gemonteerd op ' + builds.length + (builds.length === 1 ? ' H&S Garage auto' : ' H&S Garage auto\'s');
          }

          grid.innerHTML = builds.slice(0, 4).map(function (build) {
            return buildCardTemplate(build, '/apps/garage/public/builds');
          }).join('');
        })
        .catch(function () {
          block.hidden = true;
        });
    });
  }

  function highlightCardTemplate(build, detailBaseUrl, label) {
    var title = buildTitle(build);
    var image = build.mainImage || '';
    var href = build.url || detailUrl(detailBaseUrl, build);
    var views = Number(build.viewCount || 0);
    var isTrending = String(label || '').toLowerCase().indexOf('trending') !== -1;

    return [
      '<article class="hs-garage-highlight-card' + (isTrending ? ' hs-garage-highlight-card--trending' : '') + '">',
      '<a class="hs-garage-highlight-card__media" href="' + escapeHtml(href) + '" aria-label="Bekijk ' + escapeHtml(title) + ' build">',
      image ? responsiveImage(image, build.mainImageAlt || title, { width: 640, widths: [320, 480, 640, 900], sizes: '(max-width: 700px) 100vw, 33vw' }) : '<div class="hs-garage-card__fallback"></div>',
      '<span>' + escapeHtml(label || 'Build') + '</span>',
      '</a>',
      '<div class="hs-garage-highlight-card__body">',
      '<h3>' + escapeHtml(title) + '</h3>',
      '<p>' + escapeHtml(buildMeta(build).join(' · ') || 'H&S Garage build') + '</p>',
      '<strong>' + formatNumber(views) + ' weergaven' + (isTrending ? ' · populair' : '') + '</strong>',
      '<a class="hs-garage__button" href="' + escapeHtml(href) + '">Bekijk Garage</a>',
      '</div>',
      '</article>',
    ].join('');
  }

  function buildCardTemplate(build, detailBaseUrl) {
    var title = buildTitle(build);
    var image = build.mainImage || '';
    var href = build.url || detailUrl(detailBaseUrl, build);
    var categories = categoriesForBuild(build).slice(0, 4);
    var description = cardExcerpt(build.description || (build.isNew ? 'Net online gezet door een H&S Corse klant.' : 'Bekijk de foto\'s, onderdelen en setup van deze H&S Corse garage.'), 94);
    var chips = [
      build.stage,
      build.powerHp ? build.powerHp + ' PK' : '',
      categories[0],
    ].filter(Boolean).slice(0, 3);
    var search = [
      title,
      build.ownerDisplayName,
      build.brand,
      build.model,
      build.variant,
      build.year,
      build.stage,
      build.powerHp,
      build.description,
      categories.join(' '),
      (build.modifications || []).map(function (modification) {
        return [modification.title, modification.brand, modification.category].filter(Boolean).join(' ');
      }).join(' '),
    ].filter(Boolean).join(' ');

    return [
      '<article class="hs-garage-card" data-garage-card',
      ' data-brand="' + escapeHtml(build.brand || '') + '"',
      ' data-model="' + escapeHtml([build.model, build.variant].filter(Boolean).join(' ')) + '"',
      ' data-stage="' + escapeHtml(build.stage || '') + '"',
      ' data-categories="' + escapeHtml(categories.join(' ')) + '"',
      ' data-search="' + escapeHtml(search) + '">',
      '<a class="hs-garage-card__media" href="' + escapeHtml(href) + '" aria-label="Bekijk ' + escapeHtml(title) + ' build">',
      image ? responsiveImage(image, build.mainImageAlt || title, { width: 700, widths: [360, 520, 700, 960], sizes: '(max-width: 700px) 100vw, 33vw' }) : '<div class="hs-garage-card__fallback"></div>',
      buildBadgeTemplate(build),
      '</a>',
      '<div class="hs-garage-card__content">',
      '<h3>' + escapeHtml(title) + '</h3>',
      build.ownerDisplayName ? '<p class="hs-garage-card__owner">Naam eigenaar auto: ' + escapeHtml(build.ownerDisplayName) + '</p>' : '',
      chips.length ? '<div class="hs-garage-card__chips">' + chips.map(function (chip) {
        return '<span class="hs-garage-chip">' + escapeHtml(chip) + '</span>';
      }).join('') + '</div>' : '',
      '<p class="hs-garage-card__description">' + escapeHtml(description) + '</p>',
      '<div class="hs-garage-card__engagement">',
      likeButtonTemplate(build, true),
      favoriteButtonTemplate(build, true),
      commentCountTemplate(build, true),
      '</div>',
      '<a class="hs-garage__button hs-garage-card__button" href="' + escapeHtml(href) + '">Bekijk garage</a>',
      '</div>',
      '</article>',
    ].join('');
  }

  function buildBadgeTemplate(build) {
    var badges = [];

    if (build._hsGarageTrendingRank) {
      badges.push('<span class="hs-garage-card__badge hs-garage-card__badge--trending">Trending #' + build._hsGarageTrendingRank + '</span>');
    } else if (build.isNew) {
      badges.push('<span class="hs-garage-card__badge hs-garage-card__badge--new">Nieuw</span>');
    } else if (build.isRecentlyUpdated) {
      badges.push('<span class="hs-garage-card__badge hs-garage-card__badge--update">Update</span>');
    }

    if (!badges.length) return '';
    return '<div class="hs-garage-card__badges">' + badges.join('') + '</div>';
  }

  function detailContentTemplate(build) {
    var photos = build.photos || build.publicPhotos || [];
    var dynoPhotos = photos.filter(isDynoPhoto);
    var galleryPhotos = photos.filter(function (photo) {
      return !isDynoPhoto(photo);
    });
    var visibleGalleryPhotos = galleryPhotos.length ? galleryPhotos : photos;
    var description = build.description || 'Deze H&S Garage build is gedeeld door een klant van H&S Corse.';

    return [
      '<div class="hs-garage-detail-actions">',
      '<a class="hs-garage__button hs-garage__button--ghost" href="/pages/hs-garage">Terug naar H&S Garage overzicht</a>',
      '</div>',
      '<div class="hs-garage__detail-layout">',
      '<div class="hs-garage__main-stack">',
      '<div class="hs-garage__panel">',
      '<h2>Foto\'s van mijn auto</h2>',
      galleryTemplate(visibleGalleryPhotos),
      '</div>',
      '<section class="hs-garage__panel hs-garage-about">',
      '<h2>Over mijn auto</h2>',
      readMoreTemplate(description),
      '</section>',
      '</div>',
      '<div class="hs-garage__side-stack">',
      specsTemplate(build),
      dynoTemplate(dynoPhotos),
      '</div>',
      '</div>',
      '<section class="hs-garage__panel hs-garage__mods-section">',
      '<div class="hs-garage__section-head"><div><h2>Gemonteerde onderdelen</h2><p>Onderdelen en upgrades per categorie, met productlinks waar beschikbaar.</p></div></div>',
      groupedModsTemplate(build.modifications || []),
      '</section>',
    ].join('');
  }

  function specsTemplate(build) {
    var specs = [
      ['Eigenaar', build.ownerDisplayName],
      ['Merk', build.brand],
      ['Model', [build.model, build.variant].filter(Boolean).join(' ')],
      ['Bouwjaar', build.year],
      ['Motor', build.engine],
      ['Vermogen', build.powerHp ? build.powerHp + ' PK' : ''],
      ['Koppel', build.torqueNm ? build.torqueNm + ' Nm' : ''],
      ['Stage', build.stage],
      ['Kleur', build.color],
      ['Land/regio', build.country],
    ].filter(function (item) {
      return item[1];
    });

    return [
      '<aside class="hs-garage__specs" aria-label="Build specificaties">',
      specs.map(function (item) {
        return '<div class="hs-garage__spec"><span>' + escapeHtml(item[0]) + '</span><strong>' + escapeHtml(item[1]) + '</strong></div>';
      }).join(''),
      '</aside>',
    ].join('');
  }

  function socialLinksTemplate(build) {
    var links = [
      ['instagram', 'Instagram', build.instagramUrl],
      ['facebook', 'Facebook', build.facebookUrl],
      ['tiktok', 'TikTok', build.tiktokUrl],
    ].filter(function (item) {
      return safeLinkUrl(item[2]);
    });

    if (!links.length) return '';

    return [
      '<div class="hs-garage-socials" aria-label="Social links eigenaar">',
      links.map(function (item) {
        return [
          '<a class="hs-garage-social-link" href="' + escapeHtml(safeLinkUrl(item[2])) + '" target="_blank" rel="noopener">',
          '<span class="hs-garage-social-link__icon" aria-hidden="true">' + escapeHtml(socialIconLabel(item[0])) + '</span>',
          '<span>' + escapeHtml(item[1]) + ' volgen</span>',
          '</a>',
        ].join('');
      }).join(''),
      '</div>',
    ].join('');
  }

  function likeButtonTemplate(build, small) {
    var slug = build.slug || build.handle || '';
    var count = Number(build.likeCount || 0);
    var liked = Boolean(build.likedByCurrentCustomer);
    var label = count === 1 ? 'like' : 'likes';
    if (!slug) return '';

    return [
      '<button class="hs-garage-like' + (small ? ' hs-garage-like--small' : '') + (liked ? ' is-liked' : '') + '" type="button"',
      ' data-garage-like data-garage-like-slug="' + escapeHtml(slug) + '"',
      ' data-garage-like-url="/apps/garage/public/builds/' + encodeURIComponent(slug) + '/like"',
      ' aria-pressed="' + (liked ? 'true' : 'false') + '"',
      ' aria-label="' + count + ' ' + label + '">',
      '<span aria-hidden="true">' + (liked ? '♥' : '♡') + '</span>',
      '<strong data-garage-like-count>' + count + '</strong>',
      small ? '' : '<em>' + label + '</em>',
      '</button>',
    ].join('');
  }

  function favoriteButtonTemplate(build, small) {
    var slug = build.slug || build.handle || '';
    var count = Number(build.favoriteCount || 0);
    var favorited = Boolean(build.favoritedByCurrentCustomer);
    var label = count === 1 ? 'favoriet' : 'favorieten';
    if (!slug) return '';

    return [
      '<button class="hs-garage-favorite' + (small ? ' hs-garage-favorite--small' : '') + (favorited ? ' is-favorited' : '') + '" type="button"',
      ' data-garage-favorite data-garage-favorite-slug="' + escapeHtml(slug) + '"',
      ' data-garage-favorite-url="/apps/garage/public/builds/' + encodeURIComponent(slug) + '/favorite"',
      ' aria-pressed="' + (favorited ? 'true' : 'false') + '"',
      ' aria-label="' + count + ' ' + label + '">',
      '<span aria-hidden="true">' + (favorited ? '★' : '☆') + '</span>',
      '<strong data-garage-favorite-count>' + count + '</strong>',
      small ? '' : '<em>' + label + '</em>',
      '</button>',
    ].join('');
  }

  function commentCountTemplate(build, small) {
    var count = Number(build.commentCount || 0);

    return [
      '<span class="hs-garage-comment-count' + (small ? ' hs-garage-comment-count--small' : '') + '" aria-label="' + count + (count === 1 ? ' reactie' : ' reacties') + '">',
      '<strong>' + count + '</strong>',
      '<em>' + (count === 1 ? 'reactie' : 'reacties') + '</em>',
      '</span>',
    ].join('');
  }

  function shareButtonTemplate(build) {
    var slug = build.slug || build.handle || '';
    if (!slug) return '';

    return [
      '<button class="hs-garage-share" type="button"',
      ' data-garage-share data-garage-share-slug="' + escapeHtml(slug) + '"',
      ' data-garage-share-url="/apps/garage/public/builds/' + encodeURIComponent(slug) + '">',
      'Delen',
      '</button>',
    ].join('');
  }

  function buildEngagementTemplate(build) {
    return [
      '<div class="hs-garage-engagement">',
      likeButtonTemplate(build, false),
      favoriteButtonTemplate(build, false),
      shareButtonTemplate(build),
      '</div>',
    ].join('');
  }

  function ownerCardTemplate(build) {
    var ownerName = String(build.ownerDisplayName || 'H&S Garage eigenaar');
    var ownerImage = build.ownerProfileImage || '';
    var ownerImageAlt = build.ownerProfileImageAlt || ownerName;
    var initial = ownerName.trim().slice(0, 1).toUpperCase() || 'H';
    var avatar = ownerImage ? [
      '<button class="hs-garage-owner-card__avatar hs-garage-owner-card__avatar--button" type="button"',
      ' data-garage-lightbox-src="' + escapeHtml(ownerImage) + '"',
      ' data-garage-lightbox-alt="' + escapeHtml(ownerImageAlt) + '"',
      ' aria-label="Bekijk profielfoto van ' + escapeHtml(ownerName) + '">',
      responsiveImage(ownerImage, ownerImageAlt, { width: 160, widths: [96, 160, 240], sizes: '58px' }),
      '</button>',
    ].join('') : '<span class="hs-garage-owner-card__avatar hs-garage-owner-card__avatar--fallback">' + escapeHtml(initial) + '</span>';

    return [
      '<section class="hs-garage-owner-card" aria-label="Eigenaar van deze garage">',
      avatar,
      '<div class="hs-garage-owner-card__body">',
      '<span>Eigenaar garage</span>',
      '<strong>' + escapeHtml(ownerName) + '</strong>',
      '</div>',
      socialLinksTemplate(build),
      '</section>',
    ].join('');
  }

  function socialIconLabel(platform) {
    return {
      instagram: 'IG',
      facebook: 'f',
      tiktok: 'TT',
    }[platform] || '*';
  }

  function galleryTemplate(photos) {
    if (!photos.length) return '<div class="hs-garage__empty">Deze build heeft nog geen openbare foto\'s.</div>';
    var first = photos[0];
    var firstTitle = first.title || 'H&S Garage foto';
    var firstAlt = first.imageAlt || firstTitle;

    return [
      '<div class="hs-garage__gallery" data-garage-focus-gallery>',
      '<button class="hs-garage-gallery-main" type="button" data-garage-gallery-main data-garage-lightbox-src="' + escapeHtml(first.imageUrl) + '" data-garage-lightbox-alt="' + escapeHtml(firstAlt) + '">',
      responsiveImage(first.imageUrl, firstAlt, { width: 1200, widths: [520, 760, 1200, 1600], sizes: '(max-width: 900px) 100vw, 760px', attrs: 'data-garage-gallery-main-image' }),
      '<span data-garage-gallery-main-title>' + escapeHtml(firstTitle) + '</span>',
      '</button>',
      photos.length > 1 ? '<div class="hs-garage-gallery-thumbs' + (photos.length >= 6 ? ' has-scroll' : '') + '" aria-label="Andere foto\'s van deze auto">' + photos.map(function (photo, index) {
        var title = photo.title || 'H&S Garage foto';
        var alt = photo.imageAlt || title;
        return [
          '<button class="hs-garage-gallery-thumb' + (index === 0 ? ' is-active' : '') + '" type="button" aria-label="Bekijk foto: ' + escapeHtml(title) + '" data-garage-gallery-thumb data-image-src="' + escapeHtml(photo.imageUrl) + '" data-image-alt="' + escapeHtml(alt) + '" data-image-title="' + escapeHtml(title) + '" aria-current="' + (index === 0 ? 'true' : 'false') + '">',
          responsiveImage(photo.imageUrl, alt, { width: 420, widths: [260, 360, 420, 560], sizes: '(max-width: 820px) 33vw, 124px' }),
          '</button>',
        ].join('');
      }).join('') + '</div>' : '',
      '</div>',
    ].join('');
  }

  function dynoTemplate(photos) {
    if (!photos.length) return '';

    return [
      '<section class="hs-garage__panel hs-garage-dyno">',
      '<h2>Dyno sheet</h2>',
      '<div class="hs-garage-dyno__grid">',
      photos.map(function (photo) {
        var title = photo.title || 'Dyno sheet';
        return [
          '<div>',
          '<button class="hs-garage-dyno__image" type="button" data-garage-lightbox-src="' + escapeHtml(photo.imageUrl) + '" data-garage-lightbox-alt="' + escapeHtml(photo.imageAlt || title) + '">',
          responsiveImage(photo.imageUrl, photo.imageAlt || title, { width: 900, widths: [420, 700, 900, 1200], sizes: '(max-width: 900px) 100vw, 420px' }),
          '</button>',
          photo.title ? '<strong>' + escapeHtml(photo.title) + '</strong>' : '',
          photo.description ? '<p>' + escapeHtml(photo.description) + '</p>' : '',
          '</div>',
        ].join('');
      }).join(''),
      '</div>',
      '</section>',
    ].join('');
  }

  function readMoreTemplate(text) {
    var fullText = String(text || '').trim();
    var shortText = truncate(fullText, 250);
    var canExpand = fullText.length > shortText.length;

    return [
      '<div class="hs-garage-readmore" data-garage-readmore data-expanded="false" data-garage-full="' + escapeHtml(fullText) + '" data-garage-short="' + escapeHtml(shortText) + '">',
      '<p data-garage-readmore-copy>' + escapeHtml(shortText) + '</p>',
      canExpand ? '<button class="hs-garage-readmore__button" type="button" data-garage-readmore-toggle>Lees meer</button>' : '',
      '</div>',
    ].join('');
  }

  function groupedModsTemplate(modifications) {
    if (!modifications.length) {
      return '<div class="hs-garage__empty">Deze build heeft nog geen openbare onderdelen.</div>';
    }

    var groups = {};
    modifications.forEach(function (modification) {
      var category = modification.category || 'Overig';
      if (!groups[category]) groups[category] = [];
      groups[category].push(modification);
    });

    return Object.keys(groups)
      .sort(function (a, b) {
        var aIndex = CATEGORY_ORDER.indexOf(a);
        var bIndex = CATEGORY_ORDER.indexOf(b);
        return (aIndex === -1 ? 99 : aIndex) - (bIndex === -1 ? 99 : bIndex);
      })
      .map(function (category) {
        return [
          '<section class="hs-garage-category">',
          '<h3>' + escapeHtml(category) + '</h3>',
          '<div class="hs-garage__mods">',
          groups[category].map(modTemplate).join(''),
          '</div>',
          '</section>',
        ].join('');
      }).join('');
  }

  function modTemplate(modification) {
    var product = modification.product;
    var image = modification.imageUrl || (product && product.imageUrl) || '';
    var productUrl = product && product.url ? product.url : '';
    var externalUrl = safeLinkUrl(modification.externalUrl);
    var actionUrl = productUrl || externalUrl;
    var isExternal = actionUrl && /^https?:\/\//i.test(actionUrl);
    var status = {
      mounted: 'Gemonteerd',
      planned: 'Gepland',
      wishlist: 'Wishlist',
    }[modification.status] || modification.status || 'Gemonteerd';

    return [
      '<article class="hs-garage-mod">',
      actionUrl ? '<a class="hs-garage-mod__media" href="' + escapeHtml(actionUrl) + '"' + (isExternal ? ' target="_blank" rel="noopener"' : '') + '>' : '<div class="hs-garage-mod__media">',
      image ? responsiveImage(image, modification.imageAlt || modification.title, { width: 420, widths: [220, 320, 420, 640], sizes: '(max-width: 720px) 45vw, 220px' }) : '',
      '<span class="hs-garage-mod__status">' + escapeHtml(status) + '</span>',
      actionUrl ? '</a>' : '</div>',
      '<div>',
      '<span class="hs-garage-mod__category">' + escapeHtml(modification.category || 'Overig') + '</span>',
      '<h3>' + escapeHtml(modification.title || 'Onderdeel') + '</h3>',
      modification.brand ? '<p>' + escapeHtml(modification.brand) + '</p>' : '',
      modification.description ? '<p>' + escapeHtml(modification.description) + '</p>' : '',
      '</div>',
      productUrl ? '<a class="hs-garage__button" href="' + escapeHtml(productUrl) + '">Bekijk product</a>' : (externalUrl ? '<a class="hs-garage__button" href="' + escapeHtml(externalUrl) + '" target="_blank" rel="noopener">Bekijk link</a>' : ''),
      '</article>',
    ].join('');
  }

  function detailUrl(baseUrl, build) {
    var slug = build.slug || build.handle || '';
    if (!slug) return '/pages/hs-garage';
    if (baseUrl.indexOf('?') !== -1) {
      return baseUrl + encodeURIComponent(slug);
    }
    return baseUrl.replace(/\/$/, '') + '/' + encodeURIComponent(slug);
  }

  function buildTitle(build) {
    return build.title || [build.brand, build.model, build.variant].filter(Boolean).join(' ') || 'H&S Garage build';
  }

  function buildMeta(build) {
    return [
      build.year,
      build.stage,
      build.powerHp ? build.powerHp + ' PK' : '',
    ].filter(Boolean);
  }

  function buildTinyMeta(build, fallback) {
    var items = [
      build.stage,
      build.powerHp ? build.powerHp + ' PK' : '',
      fallback,
    ].filter(Boolean);

    return items.join(' · ');
  }

  function buildPhotoCount(build) {
    var photos = build.photos || build.publicPhotos || [];
    if (Array.isArray(photos)) return photos.length;
    return Number(build.photoCount || 0);
  }

  function dateValue(value) {
    var timestamp = Date.parse(value || '');
    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  function addedDateValue(build) {
    return dateValue(build && (build.publishedAt || build.createdAt));
  }

  function dateLabel(value) {
    var timestamp = Date.parse(value || '');
    if (Number.isNaN(timestamp)) return '';

    return new Intl.DateTimeFormat('nl-NL', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(new Date(timestamp));
  }

  function formatNumber(value) {
    return new Intl.NumberFormat('nl-NL').format(Number(value || 0));
  }

  function unique(items) {
    var seen = {};
    return items.filter(function (item) {
      if (!item || seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function truncate(value, length) {
    var text = String(value || '').trim();
    if (text.length <= length) return text;
    return text.slice(0, length).replace(/\s+\S*$/, '').trim() + '...';
  }

  function cardExcerpt(value, length) {
    var text = String(value || '')
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/[•·]+/g, ' ')
      .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '')
      .replace(/[\uFE0E\uFE0F\u200D]/g, '')
      .replace(/\s[-–—]\s*/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return truncate(text, length);
  }

  function isDynoPhoto(photo) {
    return normalize(photo && photo.photoType) === 'dyno';
  }

  function safeLinkUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (url.charAt(0) === '/') return url;
    if (/^https?:\/\//i.test(url)) return url;
    return '';
  }

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function classToken(value) {
    return normalize(value).replace(/[^a-z0-9_-]/g, '') || 'update';
  }

  async function loadJson(url) {
    var response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    var contentType = response.headers.get('content-type') || '';

    if (contentType.indexOf('application/json') === -1) {
      throw new Error('Geen JSON');
    }

    var payload = await response.json();
    if (!response.ok) throw new Error(payload.error || 'Aanvraag mislukt');
    return payload;
  }

  async function readJson(response) {
    var contentType = response.headers.get('content-type') || '';

    if (contentType.indexOf('application/json') === -1) {
      throw new Error('Geen geldige H&S Garage reactie.');
    }

    var payload = await response.json();
    return payload || {};
  }

  function initLightbox() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-garage-lightbox-src]');
      if (!trigger) return;
      event.preventDefault();
      openLightbox(trigger.dataset.garageLightboxSrc, trigger.dataset.garageLightboxAlt || '');
    });
  }

  function initReadMore() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-garage-readmore-toggle]');
      if (!button) return;

      var root = button.closest('[data-garage-readmore]');
      var copy = root && root.querySelector('[data-garage-readmore-copy]');
      if (!root || !copy) return;

      var expanded = root.dataset.expanded === 'true';
      var shortTemplate = root.querySelector('[data-garage-readmore-short]');
      var fullTemplate = root.querySelector('[data-garage-readmore-full]');
      root.dataset.expanded = expanded ? 'false' : 'true';
      if (shortTemplate && fullTemplate) {
        copy.innerHTML = expanded ? shortTemplate.innerHTML : fullTemplate.innerHTML;
      } else {
        copy.textContent = expanded ? root.dataset.garageShort : root.dataset.garageFull;
      }
      button.textContent = expanded ? 'Lees meer' : 'Toon minder';
    });
  }

  function initFocusGalleries() {
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-garage-gallery-thumb]');
      if (!thumb) return;

      event.preventDefault();

      var gallery = thumb.closest('[data-garage-focus-gallery]');
      var main = gallery && gallery.querySelector('[data-garage-gallery-main]');
      var mainImage = gallery && gallery.querySelector('[data-garage-gallery-main-image]');
      var mainTitle = gallery && gallery.querySelector('[data-garage-gallery-main-title]');

      if (!gallery || !main || !mainImage) return;

      var src = thumb.dataset.imageSrc || '';
      var alt = thumb.dataset.imageAlt || '';
      var title = thumb.dataset.imageTitle || '';

      if (!src) return;

      main.dataset.garageLightboxSrc = src;
      main.dataset.garageLightboxAlt = alt;
      swapGalleryMainImage(mainImage, thumb, src, alt);
      if (mainTitle) mainTitle.textContent = title;

      Array.prototype.slice.call(gallery.querySelectorAll('[data-garage-gallery-thumb]')).forEach(function (button) {
        var active = button === thumb;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    });
  }

  function initGalleryPreloading() {
    document.addEventListener('pointerover', function (event) {
      var thumb = event.target.closest('[data-garage-gallery-thumb], [data-pro-gallery-thumb]');
      if (!thumb || thumb.dataset.galleryPreviewPrimed === 'true') return;

      var src = thumb.dataset.imageSrc || thumb.dataset.src || '';
      if (!src) return;

      thumb.dataset.galleryPreviewPrimed = 'true';
      var preload = new Image();
      preload.srcset = optimizedImageSrcset(src, [520, 760, 1200, 1600]);
      preload.sizes = '(max-width: 900px) 100vw, 760px';
      preload.src = optimizedImageUrl(src, 1200);
    }, { passive: true });
  }

  function initProDetailInteractions() {
    Array.prototype.slice.call(document.querySelectorAll('.hs-garage-build-detail-pro')).forEach(updateProModGrid);

    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('.hs-garage-build-detail-pro [data-pro-gallery-thumb]');
      if (thumb) {
        event.preventDefault();
        updateProGallery(thumb);
        return;
      }

      var ownerOpen = event.target.closest('.hs-garage-build-detail-pro [data-owner-garage-open]');
      if (ownerOpen) {
        event.preventDefault();
        var ownerRoot = ownerOpen.closest('.hs-garage-build-detail-pro');
        var modal = ownerRoot && ownerRoot.querySelector('[data-owner-garage-modal]');
        if (modal) {
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
        }
        return;
      }

      var ownerClose = event.target.closest('.hs-garage-build-detail-pro [data-owner-garage-close]');
      var ownerBackdrop = event.target.matches && event.target.matches('.hs-garage-build-detail-pro [data-owner-garage-modal]');
      if (ownerClose || ownerBackdrop) {
        event.preventDefault();
        var closeRoot = event.target.closest('.hs-garage-build-detail-pro');
        closeOwnerGarageModal(closeRoot);
        return;
      }

      var statusButton = event.target.closest('.hs-garage-build-detail-pro [data-status-filter]');
      if (statusButton) {
        event.preventDefault();
        setActiveProButton(statusButton, '[data-status-filter]');
        resetProModPage(statusButton.closest('.hs-garage-build-detail-pro'));
        return;
      }

      var filterButton = event.target.closest('.hs-garage-build-detail-pro [data-filter]');
      if (filterButton) {
        event.preventDefault();
        setActiveProButton(filterButton, '[data-filter]');
        resetProModPage(filterButton.closest('.hs-garage-build-detail-pro'));
        return;
      }

      var pageButton = event.target.closest('.hs-garage-build-detail-pro [data-mod-page]');
      if (pageButton && pageButton.tagName === 'BUTTON') {
        event.preventDefault();
        changeProModPage(pageButton);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      Array.prototype.slice.call(document.querySelectorAll('.hs-garage-build-detail-pro')).forEach(closeOwnerGarageModal);
    });
  }

  function updateProGallery(thumb) {
    var gallery = thumb.closest('[data-pro-gallery]');
    var main = gallery && gallery.querySelector('.gallery-main');
    var mainImage = gallery && gallery.querySelector('[data-main-image]');
    var mainTitle = gallery && gallery.querySelector('[data-main-title]');
    var mainCount = gallery && gallery.querySelector('[data-main-count]');
    var src = thumb.dataset.src || '';
    var alt = thumb.dataset.alt || '';
    var title = thumb.dataset.title || '';
    var index = thumb.dataset.index || '';

    if (!gallery || !main || !mainImage || !src) return;

    main.dataset.garageLightboxSrc = src;
    main.dataset.garageLightboxAlt = alt;
    swapGalleryMainImage(mainImage, thumb, src, alt);
    if (mainTitle) mainTitle.textContent = title;
    if (mainCount) {
      mainCount.textContent = index + ' / ' + gallery.querySelectorAll('[data-pro-gallery-thumb]').length;
    }

    Array.prototype.slice.call(gallery.querySelectorAll('[data-pro-gallery-thumb]')).forEach(function (button) {
      var active = button === thumb;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function swapGalleryMainImage(mainImage, thumb, src, alt) {
    var thumbImage = thumb && thumb.querySelector('img');
    var instantSrc = thumbImage && (thumbImage.currentSrc || thumbImage.src);
    var sharpSrc = optimizedImageUrl(src, 1200);
    var sharpSrcset = optimizedImageSrcset(src, [520, 760, 1200, 1600]);
    var token = String(Date.now()) + Math.random().toString(16).slice(2);

    mainImage.dataset.gallerySwapToken = token;
    mainImage.alt = alt;
    mainImage.sizes = '(max-width: 900px) 100vw, 760px';

    if (instantSrc && instantSrc !== mainImage.currentSrc) {
      mainImage.removeAttribute('srcset');
      mainImage.src = instantSrc;
    }

    window.setTimeout(function () {
      if (mainImage.dataset.gallerySwapToken !== token) return;
      mainImage.src = sharpSrc;
      mainImage.srcset = sharpSrcset;
    }, 80);
  }

  function setActiveProButton(button, selector) {
    var group = button.parentElement;
    if (!group) return;

    Array.prototype.slice.call(group.querySelectorAll(selector)).forEach(function (item) {
      item.classList.toggle('is-active', item === button);
    });
  }

  function updateProModGrid(root) {
    if (!root) return;

    var modsSection = root.querySelector('[data-mods-section]') || root;
    var statusButton = root.querySelector('[data-status-filter].is-active');
    var categoryButton = root.querySelector('[data-filter].is-active');
    var status = statusButton ? statusButton.dataset.statusFilter : 'mounted';
    var category = categoryButton ? categoryButton.dataset.filter : 'all';
    var pageSize = Math.max(1, Number(modsSection.dataset.modPageSize || 8));
    var page = Math.max(1, Number(modsSection.dataset.modPage || 1));
    var matchingCards = [];
    var cards = Array.prototype.slice.call(modsSection.querySelectorAll('.mod-card'));

    cards.forEach(function (card) {
      var matchesStatus = !status || card.dataset.status === status;
      var matchesCategory = !category || category === 'all' || card.dataset.category === category;
      if (matchesStatus && matchesCategory) matchingCards.push(card);
    });

    var visibleCount = matchingCards.length;
    var totalPages = Math.max(1, Math.ceil(visibleCount / pageSize));
    page = Math.min(page, totalPages);
    modsSection.dataset.modPage = String(page);

    cards.forEach(function (card) {
      card.hidden = true;
    });

    matchingCards.forEach(function (card, index) {
      var onPage = index >= (page - 1) * pageSize && index < page * pageSize;
      card.hidden = !onPage;
    });

    var counter = root.querySelector('[data-mod-count]');
    if (counter) {
      counter.textContent = visibleCount + (visibleCount === 1 ? ' mod' : ' mods');
    }

    var pagination = modsSection.querySelector('[data-mod-pagination]');
    if (!pagination) return;

    var label = pagination.querySelector('[data-mod-page-label]');
    var previous = pagination.querySelector('[data-mod-page="prev"]');
    var next = pagination.querySelector('[data-mod-page="next"]');
    pagination.hidden = visibleCount <= pageSize;
    if (label) label.textContent = 'Pagina ' + page + ' / ' + totalPages;
    if (previous) previous.disabled = page <= 1;
    if (next) next.disabled = page >= totalPages;
  }

  function resetProModPage(root) {
    var modsSection = root && root.querySelector('[data-mods-section]');
    if (modsSection) modsSection.dataset.modPage = '1';
    updateProModGrid(root);
  }

  function changeProModPage(button) {
    var root = button.closest('.hs-garage-build-detail-pro');
    var modsSection = button.closest('[data-mods-section]');
    if (!root || !modsSection) return;

    var direction = button.dataset.modPage;
    var current = Math.max(1, Number(modsSection.dataset.modPage || 1));
    modsSection.dataset.modPage = String(direction === 'next' ? current + 1 : current - 1);
    updateProModGrid(root);
    modsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function closeOwnerGarageModal(root) {
    if (!root) return;
    var modal = root.querySelector('[data-owner-garage-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  function initLikes() {
    document.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-garage-like]');
      if (!button) return;

      event.preventDefault();
      if (button.disabled) return;

      button.disabled = true;

      try {
        var response = await fetch(button.dataset.garageLikeUrl, {
          method: 'POST',
          body: new FormData(),
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (response.status === 401) {
          window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
          return;
        }

        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Like opslaan is mislukt.');
        }

        updateLikeButtons(button.dataset.garageLikeSlug, payload.liked, payload.likeCount);
        if (payload.liked) {
          showGarageActionToastFromButton(button, {
            type: 'like',
            kicker: 'Zojuist geliked',
            title: 'Deze garage is zojuist geliked',
          });
        }
      } catch (error) {
        if (String(error.message || '').indexOf('Login vereist') !== -1) {
          window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
        } else {
          window.alert(error.message || 'Like opslaan is mislukt.');
        }
      } finally {
        button.disabled = false;
      }
    });
  }

  function initFavorites() {
    document.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-garage-favorite]');
      if (!button) return;

      event.preventDefault();
      if (button.disabled) return;

      button.disabled = true;

      try {
        var response = await fetch(button.dataset.garageFavoriteUrl, {
          method: 'POST',
          body: new FormData(),
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (response.status === 401) {
          window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
          return;
        }

        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Favoriet opslaan is mislukt.');
        }

        updateFavoriteButtons(button.dataset.garageFavoriteSlug, payload.favorited, payload.favoriteCount);
        if (payload.favorited) {
          showGarageActionToastFromButton(button, {
            type: 'favorite',
            kicker: 'Nieuwe favoriet',
            title: 'Deze garage is opgeslagen als favoriet',
          });
        }
      } catch (error) {
        if (String(error.message || '').indexOf('Login vereist') !== -1) {
          window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
        } else {
          window.alert(error.message || 'Favoriet opslaan is mislukt.');
        }
      } finally {
        button.disabled = false;
      }
    });
  }

  function initComments() {
    document.addEventListener('click', function (event) {
      var reactionButton = event.target.closest('[data-garage-comment-reaction]');
      if (reactionButton) {
        event.preventDefault();
        toggleCommentReaction(reactionButton);
        return;
      }

      var emojiButton = event.target.closest('[data-comment-emoji]');
      if (emojiButton) {
        event.preventDefault();

        var emojiForm = emojiButton.closest('[data-garage-comment-form]');
        var emojiTextarea = emojiForm && emojiForm.querySelector('textarea[name="body"]');
        var emoji = emojiButton.dataset.commentEmoji || '';
        if (!emojiTextarea || !emoji) return;

        insertTextAtCursor(emojiTextarea, emoji + ' ');
        return;
      }

      var replyButton = event.target.closest('[data-comment-reply]');
      if (replyButton) {
        event.preventDefault();
        startCommentReply(replyButton);
        return;
      }

      var cancelReply = event.target.closest('[data-comment-reply-cancel]');
      if (cancelReply) {
        event.preventDefault();
        clearCommentReply(cancelReply.closest('[data-garage-comment-form]'));
        return;
      }

      var deleteButton = event.target.closest('[data-garage-comment-delete]');
      if (deleteButton) {
        event.preventDefault();
        deleteOwnComment(deleteButton);
      }
    });

    document.addEventListener('submit', async function (event) {
      var form = event.target.closest('[data-garage-comment-form]');
      if (!form) return;

      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var message = form.querySelector('[data-garage-comment-message]');
      var originalText = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'Reactie versturen...';
      }

      if (message) {
        message.hidden = true;
        message.classList.remove('is-error', 'is-success');
        message.textContent = '';
      }

      try {
        var response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (response.status === 401) {
          window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
          return;
        }

        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Reactie plaatsen is mislukt.');
        }

        form.reset();
        clearCommentReply(form);

        if (message) {
          message.textContent = payload.message || 'Je reactie is verstuurd en wacht op goedkeuring.';
          message.classList.add('is-success');
          message.hidden = false;
          message.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } catch (error) {
        if (message) {
          message.textContent = error.message || 'Reactie plaatsen is mislukt.';
          message.classList.add('is-error');
          message.hidden = false;
        } else {
          window.alert(error.message || 'Reactie plaatsen is mislukt.');
        }
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = originalText || 'Reactie plaatsen';
        }
      }
    });
  }

  async function toggleCommentReaction(button) {
    if (!button || button.disabled) return;

    var formData = new FormData();
    formData.append('reaction_type', button.dataset.commentReactionType || '');
    button.disabled = true;

    try {
      var response = await fetch(button.dataset.commentReactionUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (response.status === 401) {
        window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
        return;
      }

      var payload = await readJson(response);

      if (!response.ok || payload.ok === false) {
        throw new Error(payload.error || 'Waardering opslaan is mislukt.');
      }

      updateCommentReactionUi(button, payload);
    } catch (error) {
      if (String(error.message || '').indexOf('Login vereist') !== -1) {
        window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
      } else {
        window.alert(error.message || 'Waardering opslaan is mislukt.');
      }
    } finally {
      button.disabled = false;
    }
  }

  function updateCommentReactionUi(button, payload) {
    var card = button.closest('[data-comment-id]');
    if (!card) return;

    setCommentReactionState(card, 'heart', payload.heartedByCurrentCustomer, payload.heartCount);
    setCommentReactionState(card, 'thumb', payload.thumbedByCurrentCustomer, payload.thumbCount);
  }

  function setCommentReactionState(card, type, active, count) {
    var reactionButton = card.querySelector('[data-comment-reaction-type="' + type + '"]');
    if (!reactionButton) return;

    reactionButton.classList.toggle('is-active', Boolean(active));
    reactionButton.setAttribute('aria-pressed', active ? 'true' : 'false');

    var counter = reactionButton.querySelector('[data-comment-reaction-count="' + type + '"]');
    if (counter) counter.textContent = String(Number(count || 0));
  }

  function insertTextAtCursor(field, text) {
    var start = typeof field.selectionStart === 'number' ? field.selectionStart : field.value.length;
    var end = typeof field.selectionEnd === 'number' ? field.selectionEnd : field.value.length;
    field.value = field.value.slice(0, start) + text + field.value.slice(end);
    var nextPosition = start + text.length;
    field.focus();
    if (field.setSelectionRange) field.setSelectionRange(nextPosition, nextPosition);
  }

  function startCommentReply(button) {
    var root = button.closest('.hs-garage-build-detail-pro') || document;
    var form = root.querySelector('[data-garage-comment-form]');
    if (!form) return;

    var parentInput = form.querySelector('[data-comment-parent-input]');
    var context = form.querySelector('[data-comment-reply-context]');
    var label = form.querySelector('[data-comment-reply-label]');
    var textarea = form.querySelector('textarea[name="body"]');
    var author = button.dataset.commentAuthor || 'deze reactie';
    var id = button.dataset.commentId || '';

    if (parentInput) parentInput.value = id;
    if (label) label.textContent = 'Je reageert op ' + author + '.';
    if (context) context.hidden = false;

    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (textarea) textarea.focus();
  }

  function clearCommentReply(form) {
    if (!form) return;

    var parentInput = form.querySelector('[data-comment-parent-input]');
    var context = form.querySelector('[data-comment-reply-context]');
    var label = form.querySelector('[data-comment-reply-label]');

    if (parentInput) parentInput.value = '';
    if (label) label.textContent = '';
    if (context) context.hidden = true;
  }

  async function deleteOwnComment(button) {
    if (!button || button.disabled) return;

    if (!window.confirm('Weet je zeker dat je deze reactie wilt verwijderen?')) return;

    var url = button.dataset.commentDeleteUrl || button.dataset.garageCommentDeleteUrl || '';
    var card = button.closest('[data-comment-id]');
    var messageRoot = button.closest('.comments-section');

    if (!url) return;

    button.disabled = true;

    try {
      var response = await fetch(url, {
        method: 'POST',
        body: new FormData(),
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (response.status === 401) {
        window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search);
        return;
      }

      var payload = await readJson(response);

      if (!response.ok || payload.ok === false) {
        throw new Error(payload.error || 'Reactie verwijderen is mislukt.');
      }

      var removedCount = card ? Math.max(1, card.querySelectorAll('[data-comment-id]').length) : 1;
      if (card) card.remove();
      updateCommentCount(messageRoot, -removedCount);
    } catch (error) {
      window.alert(error.message || 'Reactie verwijderen is mislukt.');
    } finally {
      button.disabled = false;
    }
  }

  function updateCommentCount(root, change) {
    if (!root) return;

    var counter = root.querySelector('[data-comment-count]');
    if (!counter) return;

    var current = Number((counter.textContent || '').match(/\d+/)?.[0] || 0);
    var next = Math.max(0, current + Number(change || 0));
    counter.textContent = next + (next === 1 ? ' reactie' : ' reacties');
  }

  function initShareButtons() {
    document.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-garage-share]');
      if (!button) return;

      event.preventDefault();

      var slug = button.dataset.garageShareSlug || '';
      var sharePath = button.dataset.garageShareUrl || window.location.pathname;
      var shareUrl = new URL(sharePath, window.location.origin).toString();
      var title = document.title || 'H&S Garage build';

      try {
        if (navigator.share) {
          await navigator.share({ title: title, url: shareUrl });
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(shareUrl);
          button.textContent = 'Link gekopieerd';
          window.setTimeout(function () {
            button.textContent = 'Delen';
          }, 1800);
        }
      } catch (error) {
        return;
      }

      if (slug) {
        trackBuildEvent(slug, 'share', false);
      }
    });
  }

  function showGarageActionToastFromButton(button, options) {
    var scope = button.closest('.hs-garage-card, .hs-garage-build-detail-pro, .hs-garage-spotlight, .hs-garage-top-viewed-card') || document;
    var title = (scope.querySelector('h1, h2, h3, strong') || {}).textContent || 'H&S Garage build';
    var image = scope.querySelector('img');
    var slug = button.dataset.garageLikeSlug || button.dataset.garageFavoriteSlug || '';
    var href = slug ? '/apps/garage/public/builds/' + encodeURIComponent(slug) : window.location.pathname;

    showGarageActivityToast({
      type: options.type,
      kicker: options.kicker,
      title: options.title,
      body: title.trim(),
      href: href,
      image: image ? image.currentSrc || image.src : '',
      imageAlt: image ? image.alt : title.trim(),
    });
  }

  function initBuildTracking() {
    var roots = document.querySelectorAll('[data-garage-build-slug]');

    Array.prototype.slice.call(roots).forEach(function (root) {
      trackBuildView(root.dataset.garageBuildSlug);
    });
  }

  function trackBuildView(slug) {
    if (!slug) return;

    var key = 'hsGarageViewed:' + slug;
    var viewedAtKey = 'hsGarageViewedAt:' + slug;
    var throttleMs = 15 * 60 * 1000;
    var unique = false;
    var shouldTrack = true;

    try {
      var now = Date.now();
      var lastViewedAt = Number(window.localStorage.getItem(viewedAtKey) || 0);
      unique = window.localStorage.getItem(key) !== '1';
      shouldTrack = unique || !lastViewedAt || now - lastViewedAt > throttleMs;
      window.localStorage.setItem(key, '1');
      if (shouldTrack) window.localStorage.setItem(viewedAtKey, String(now));
    } catch (error) {
      unique = false;
    }

    if (!shouldTrack) return;
    trackBuildEvent(slug, 'view', unique);
  }

  async function trackBuildEvent(slug, eventType, unique) {
    if (!slug) return;

    var formData = new FormData();
    formData.append('event_type', eventType);
    formData.append('unique', unique ? 'true' : 'false');

    try {
      await fetch('/apps/garage/public/builds/' + encodeURIComponent(slug) + '/track', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
    } catch (error) {
      // Analytics should never interrupt the garage experience.
    }
  }

  function updateLikeButtons(slug, liked, likeCount) {
    var buttons = document.querySelectorAll('[data-garage-like-slug="' + cssEscape(slug) + '"]');

    Array.prototype.slice.call(buttons).forEach(function (button) {
      var vectorIcon = button.querySelector('[data-garage-like-icon]');
      var icon = button.querySelector('span:not([data-garage-like-label])');
      var count = button.querySelector('[data-garage-like-count]');
      var label = button.querySelector('em');

      button.classList.toggle('is-liked', Boolean(liked));
      button.classList.toggle('is-active', Boolean(liked));
      button.setAttribute('aria-pressed', liked ? 'true' : 'false');
      button.setAttribute('aria-label', String(likeCount || 0) + ' ' + (Number(likeCount || 0) === 1 ? 'like' : 'likes'));
      if (icon && !vectorIcon) icon.textContent = liked ? '♥' : '♡';
      if (count) count.textContent = String(likeCount || 0);
      if (label) label.textContent = Number(likeCount || 0) === 1 ? 'like' : 'likes';
    });

    Array.prototype.slice.call(document.querySelectorAll('[data-garage-like-total-slug="' + cssEscape(slug) + '"]')).forEach(function (count) {
      count.textContent = String(likeCount || 0);
    });
  }

  function updateFavoriteButtons(slug, favorited, favoriteCount) {
    var buttons = document.querySelectorAll('[data-garage-favorite-slug="' + cssEscape(slug) + '"]');

    Array.prototype.slice.call(buttons).forEach(function (button) {
      var vectorIcon = button.querySelector('[data-garage-favorite-icon]');
      var icon = button.querySelector('span:not([data-garage-favorite-label])');
      var count = button.querySelector('[data-garage-favorite-count]');
      var label = button.querySelector('em');

      button.classList.toggle('is-favorited', Boolean(favorited));
      button.classList.toggle('is-active', Boolean(favorited));
      button.setAttribute('aria-pressed', favorited ? 'true' : 'false');
      button.setAttribute('aria-label', String(favoriteCount || 0) + ' ' + (Number(favoriteCount || 0) === 1 ? 'favoriet' : 'favorieten'));
      if (icon && !vectorIcon) icon.textContent = favorited ? '★' : '☆';
      if (count) count.textContent = String(favoriteCount || 0);
      if (label) label.textContent = Number(favoriteCount || 0) === 1 ? 'favoriet' : 'favorieten';
    });

    Array.prototype.slice.call(document.querySelectorAll('[data-garage-favorite-total-slug="' + cssEscape(slug) + '"]')).forEach(function (count) {
      count.textContent = String(favoriteCount || 0);
    });
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(String(value || ''));
    return String(value || '').replace(/"/g, '\\"');
  }

  function openLightbox(src, alt) {
    if (!src) return;

    var existing = document.querySelector('[data-garage-lightbox]');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.className = 'hs-garage-lightbox';
    overlay.setAttribute('data-garage-lightbox', '');
    overlay.innerHTML = [
      '<button class="hs-garage-lightbox__close" type="button" aria-label="Sluiten">Sluiten</button>',
      responsiveImage(src, alt, { width: 1800, widths: [900, 1400, 1800, 2200], sizes: '96vw', loading: 'eager' }),
    ].join('');

    function closeLightbox() {
      overlay.remove();
      document.removeEventListener('keydown', closeWithEscape);
    }

    function closeWithEscape(event) {
      if (event.key === 'Escape') closeLightbox();
    }

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay || event.target.closest('.hs-garage-lightbox__close')) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', closeWithEscape);
    document.body.appendChild(overlay);
  }

  function responsiveImage(src, alt, options) {
    options = options || {};
    var width = options.width || 800;
    var widths = options.widths || [360, 540, width, 1200];
    var attrs = [
      'src="' + escapeHtml(optimizedImageUrl(src, width)) + '"',
      'alt="' + escapeHtml(alt || '') + '"',
      'loading="' + escapeHtml(options.loading || 'lazy') + '"',
      'decoding="async"',
    ];
    var srcset = optimizedImageSrcset(src, widths);

    if (srcset) attrs.push('srcset="' + escapeHtml(srcset) + '"');
    if (options.sizes) attrs.push('sizes="' + escapeHtml(options.sizes) + '"');
    if (options.fetchpriority) attrs.push('fetchpriority="' + escapeHtml(options.fetchpriority) + '"');
    if (options.attrs) attrs.push(options.attrs);

    return '<img ' + attrs.join(' ') + '>';
  }

  function optimizedImageSrcset(src, widths) {
    return (widths || [])
      .map(function (width) {
        var url = optimizedImageUrl(src, width);
        return url ? url + ' ' + width + 'w' : '';
      })
      .filter(Boolean)
      .join(', ');
  }

  function optimizedImageUrl(src, width) {
    var value = String(src || '').trim();
    if (!value || !width) return value;

    try {
      var url = new URL(value, window.location.origin);
      if (!isShopifyImageHost(url.hostname)) return value;
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (error) {
      return value;
    }
  }

  function isShopifyImageHost(hostname) {
    var host = String(hostname || '').toLowerCase();
    return host === 'cdn.shopify.com' || host.indexOf('.cdn.shopify.com') !== -1 || host.indexOf('shopifycdn.net') !== -1;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
})();
